app.controller('mainController', function ($scope, $rootScope, $routeParams, safeApply, systemService, searchService, storageService) {

    const params = $routeParams

    initController()

    // searchMethod
    // 1= for Analysis
    // 2= for File a Protest

    $scope.route = 'home'
    $scope.testimonials = []

    $rootScope.step_tracker = 1

    async function initController() {
        $rootScope.searchMethod = 1
        $rootScope.advancedSearch = false
        searchService.setSearchMethod($rootScope.searchMethod)

        if ('promocode' in params) storageService.setCookie('ptio_promocode', params.promocode, 90)

        initComponents()
        let testimonialsResults = await systemService.functionCall({ type: "testimonials" })
        if (testimonialsResults.data.success && testimonialsResults.data.data.length > 0) {
            $scope.testimonials = testimonialsResults.data.data.map(item => {
                return {
                    comment: item.comment,
                    author: item.author.split('|')[0],
                    county: item.author.split('|')[1]
                }
            })
        }

        setTimeout(() => {
            initTestimonialSlider()
            safeApply($scope)
        }, 0)

        let countyListResults = await systemService.functionCall({ type: "countyList", active_only: true })
        if (countyListResults.data.success && countyListResults.data.data.length > 0) {
            $scope.countyList = searchService.setGoogleCounties(countyListResults.data.data)
        } else {
            console.log("System Error")
            $scope.route('sign_in')
        }
        safeApply($scope)
    }

    $scope.focusInput = () => {
        document.getElementById("autocomplete").focus()
    }

    $scope.changeSearchMethod = (mode) => {
        searchService.setSearchMethod(mode)
        $rootScope.searchMethod = mode
        safeApply($scope)
    }

    $scope.open_slideshow_modal = (modal_id) => {
        if (myModal) myModal = null
        var myModal = new bootstrap.Modal(document.getElementById(modal_id))
        myModal.show()
    }

    function initComponents() {
        feather.replace()

        //Menu
        // Toggle menu
        $scope.toggleMenu = () => {
            document.getElementById('isToggle').classList.toggle('open')
            var isOpen = document.getElementById('navigation')
            if (isOpen.style.display === "block") {
                isOpen.style.display = "none"
            } else {
                isOpen.style.display = "block"
            }
        }

        //Menu Active
        function getClosest(elem, selector) {

            // Element.matches() polyfill
            if (!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) { }
                        return i > -1;
                    };
            }

            // Get the closest matching element
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.matches(selector)) return elem;
            }
            return null;

        };

        function activateMenu() {
            var menuItems = document.getElementsByClassName("sub-menu-item");
            if (menuItems) {

                var matchingMenuItem = null;
                for (var idx = 0; idx < menuItems.length; idx++) {
                    if (menuItems[idx].href === window.location.href) {
                        matchingMenuItem = menuItems[idx];
                    }
                }

                if (matchingMenuItem) {
                    matchingMenuItem.classList.add('active');
                    var immediateParent = getClosest(matchingMenuItem, 'li');
                    if (immediateParent) {
                        immediateParent.classList.add('active');
                    }

                    var parent = getClosest(matchingMenuItem, '.parent-menu-item');
                    if (parent) {
                        parent.classList.add('active');
                        var parentMenuitem = parent.querySelector('.menu-item');
                        if (parentMenuitem) {
                            parentMenuitem.classList.add('active');
                        }
                        var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                        if (parentOfParent) {
                            parentOfParent.classList.add('active');
                        }
                    } else {
                        var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                        if (parentOfParent) {
                            parentOfParent.classList.add('active');
                        }
                    }
                }
            }
        }

        // Clickable Menu
        if (document.getElementById("navigation")) {
            var elements = document.getElementById("navigation").getElementsByTagName("a");
            for (var i = 0, len = elements.length; i < len; i++) {
                elements[i].onclick = function (elem) {
                    if (elem.target.getAttribute("href") === "javascript:void(0)") {
                        var submenu = elem.target.nextElementSibling.nextElementSibling;
                        submenu.classList.toggle('open');
                    }
                }
            }
        }

        // Menu sticky
        function windowScroll() {
            const navbar = document.getElementById("topnav");
            if (navbar != null) {
                if (
                    document.body.scrollTop >= 50 ||
                    document.documentElement.scrollTop >= 50
                ) {
                    navbar.classList.add("nav-sticky");
                } else {
                    navbar.classList.remove("nav-sticky");
                }
            }
        }

        window.addEventListener('scroll', (ev) => {
            ev.preventDefault();
            windowScroll();
        })

        // back-to-top
        var mybutton = document.getElementById("back-to-top");
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (mybutton != null) {
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    mybutton.style.display = "block";
                } else {
                    mybutton.style.display = "none";
                }
            }
        }

        $scope.topFunction = () => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }

    }

    // Testimonial Slider
    var slider
    function initTestimonialSlider() {
        // console.log("init Testimonials");
        slider = tns({
            container: '.testimonial-slider',
            controls: false,
            mouseDrag: true,
            loop: true,
            rewind: true,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            navPosition: "top",
            speed: 400,
            gutter: 12,
            responsive: {
                992: { items: 3 },
                767: { items: 2 },
                320: { items: 1 },
            },
        })
    }
    // END: Testimonial Slider


})
